@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";
@use "./tokens.scss";

@mixin for-disabled($rule) {
  #{$rule}:disabled, #{$rule}.disabled {
    @content;
  }
}

.button {
  @include typography.button;
  align-items: center;
  color: var(--white);
  cursor: pointer;
  display: inline-flex;
  flex-flow: row-reverse wrap;
  flex-grow: 1;
  overflow-y: hidden;
  justify-content: center;
  padding: 0 4px;
  border-radius: 20px;
  border: solid 2px transparent;
  outline: none;

  &:focus {
   // box-shadow: 0 0 12px var(--highlight-blue);
  }
}

.button:disabled {
  cursor: not-allowed;
}

@include for-disabled(".buttonLoading") {
  background-color: var(--black-at-75);
}

.buttonStandard {
  background-color: var(--blue-01);
  min-height: tokens.$button-standard-height;

  > * {
    min-height: 45px;
  }
}

.buttonGhost {
  color: var(--blue-01);
  background-color: #143467;
  border-color: var(--blue-01);
  min-height: tokens.$button-standard-height;

  > * {
    min-height: 32px;
  }
}

.buttonGhost:hover:not(.buttonLoading) {
//  border-color: var(--highlight-blue);
}

.buttonGhost:active:not(:disabled):not(.disabled) {
 // @include tokens.button-highlight;
 // border-color: var(--highlight-blue);
}

.buttonStandard:active:not(:disabled):not(.disabled) {
 // @include tokens.button-highlight;
}

@include for-disabled(".buttonStandard:not(.buttonLoading)") {
  background-color: var(--black-at-75);
  color: var(--white);
}

// .buttonStandard:hover:not(.buttonLoading):not(:disabled):not(.disabled) {
//   background-color: var(--black);
//   border-color: var(--black);
// }

@include for-disabled(".buttonGhost:not(.buttonLoading)") {
  background-color: var(--gray-02);
  border-color: var(--gray-00);
  color: var(--gray-00);
}

@include for-disabled(".buttonGhost.buttonLoading") {
  background-color: var(--gray-02);
  border-color: var(--gray-00);
  color: var(--gray-00);
}

.buttonLarge {
  @include typography.button-large;
  min-height: tokens.$button-large-height;

  > * {
    min-height: 44px;
  }
}

.spinner {
  margin: 0 4px;
}

.text {
  justify-content: center;
  display: flex;
  align-items: center;
  overflow: hidden;
  margin: -4px 4px;
  text-align: center;
  color: white;
  font-family: typography.$font-mont;
  font-weight: 600;
  font-style: normal;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;

}